export * from './PaperclipIcon'
